export { default as Img200 } from './processed/200/Lord-Of-The-Rings-The-Fellowship-Of-The-Ring.jpg';
export { default as Img400 } from './processed/400/Lord-Of-The-Rings-The-Fellowship-Of-The-Ring.jpg';
export { default as Imgthumb } from './processed/thumb/Lord-Of-The-Rings-The-Fellowship-Of-The-Ring.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Lord-Of-The-Rings-The-Fellowship-Of-The-Ring.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Lord-Of-The-Rings-The-Fellowship-Of-The-Ring.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      168,
      82,
      70
    ],
    "_population": 4,
    "_hsl": [
      0.020408163265306124,
      0.4117647058823529,
      0.4666666666666667
    ]
  },
  "LightVibrant": {
    "_rgb": [
      216,
      233,
      209
    ],
    "_population": 240,
    "_hsl": [
      0.2847222222222222,
      0.35294117647058804,
      0.8666666666666667
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      101,
      52,
      34
    ],
    "_population": 36,
    "_hsl": [
      0.044776119402985086,
      0.4962962962962962,
      0.2647058823529412
    ]
  },
  "Muted": {
    "_rgb": [
      166,
      118,
      82
    ],
    "_population": 32,
    "_hsl": [
      0.07142857142857142,
      0.3387096774193548,
      0.4862745098039216
    ]
  },
  "LightMuted": {
    "_rgb": [
      212,
      185,
      171
    ],
    "_population": 246,
    "_hsl": [
      0.056910569105691054,
      0.3228346456692916,
      0.7509803921568627
    ]
  },
  "DarkMuted": {
    "_rgb": [
      67,
      47,
      39
    ],
    "_population": 2202,
    "_hsl": [
      0.047619047619047616,
      0.2641509433962264,
      0.20784313725490197
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Lord-Of-The-Rings-The-Fellowship-Of-The-Ring.js